import React, { Component } from 'react';
import PageTitle from './PageTitle';
import { browserHistory } from 'react-router';
import Input from './Input';
import Select from './Select';
import PubSub from 'pubsub-js';
import TratadorErros from './TratadorErros';
import $ from 'jquery';

export default class ContactFull extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nome: '',
            email: '',
            telefone: '',
            mensagem: '',
            cargo: '',
            tipoInstituicao: '',
            offices: [],
            types: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.sendContact = this.sendContact.bind(this);
    }

    componentWillMount() {

        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json'
            })
        };


        fetch('http://api.fcsistema.com.br/api-website-fc/institutionType/', requestInfo)
            .then(response => response.json())
            .then(data => {
                this.setState({ types: data });
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });

        fetch('http://api.fcsistema.com.br/api-website-fc/professionalPosition/', requestInfo)
            .then(response => response.json())
            .then(data => {
                this.setState({ offices: data });
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    handleChange(e) {
        var change = {}
        change[e.target.name] = e.target.value
        this.setState(change)
    }

    sendContact(event) {
        event.preventDefault();

        const body = JSON.stringify({
            nome: this.state.nome,
            email: this.state.email,
            telefone: this.state.telefone,
            tipoInstituicao: this.state.tipoInstituicao,
            cargo: this.state.cargo
        });

        $.ajax({
            url: 'http://api.fcsistema.com.br/api-website-fc/contactFull/save',
            contentType: 'application/json',
            dataType: 'json',
            type: 'post',
            data: body,
            success: function (response) {
                alert('Obrigado por entrar em contato, retornaremos em breve!');
                browserHistory.push('/');
            },
            error: function (response) {
                if (response.status === 400) {
                    console.log(response);
                    new TratadorErros().publicaErros(response.responseJSON);
                }
            },
            beforeSend: function () {
                PubSub.publish("limpa-erros", {});
            }
        });
    }

    render() {
        const Captcha = require('react-captcha');

        return (
            <div>
                <PageTitle title={this.props.params.type.replace('-', ' ')} last="Home" lastLink="/" />
                <section className="section-padding">

                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">{this.props.params.type.replace('-', ' ')}</h2>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <form name="contact-form" id="contactForm" onSubmit={this.sendContact} method="POST">

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="input-field">
                                                <Input type="text" name="nome" className="validate" label="Qual é o seu nome?"
                                                    autoComplete="name" id="nome" value={this.state.nome} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="input-field">
                                                <Input id="email" type="email" name="email" className="validate" label="Qual é seu email de trabalho?"
                                                    autoComplete="email"
                                                    value={this.state.email} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="input-field">
                                                <Input id="telefone" type="text" name="telefone" className="validate" label="Qual é o seu telefone?"
                                                    autoComplete="tel-national" value={this.state.telefone} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="input-field">
                                                <Select id="professionalPosition" name="cargo" className="browser-default"
                                                    values={this.state.offices} value={this.state.cargo} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="input-field">
                                                <Select id="insititutionType" name="tipoInstituicao" className="browser-default"
                                                    values={this.state.types}
                                                    value={this.state.tipoInstituicao} onChange={this.handleChange.bind(this)} />
                                            </div>
                                        </div>
                                    </div>

                                    <br />

                                    <Captcha
                                        sitekey='6LftID4UAAAAAOkYFe1Z34npeeBEQmd4Cidzw143'
                                        lang='pt-BR'
                                        theme='light'
                                        type='image'
                                        callback={(value) => console.log(value)} />


                                    <button type="submit" name="submit" className="waves-effect waves-light btn btn-blue submit-button mt-30">{this.props.params.type.replace('-', ' ')}</button>
                                </form>
                            </div>


                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ContactFull.js